export enum ModalType {
  GLOBAL = "#app",
  MAIN = "#main",
}
